import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

// DEPENDENCIES
import { useParams } from 'react-router-dom';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// GLOBAL FUNCTIONS
import { apiFetch, makePath } from 'functions.js';

// CONTEXT
export const EpostContext = createContext(null);
export const useEpostContext = () => useContext(EpostContext);

// MAIN COMPONENT
export const getEpostData = Component => props => {

  // REACT ROUTER
  const { recordID } = Object.assign({}, useParams(), props);

  // STATE
  const [epostData, setEpostData] = useState();

  // CALLBACKS
  const clearData = useCallback(
    () => {
      setEpostData(undefined);
    },
    [setEpostData]
  )

  // EFFECTS
  useEffect(() => {
    if (!recordID) {
      setEpostData();
      return;
    }
    apiFetch({
      endpoint: makePath(ENDPOINTS.deliveryLog.epostData, recordID),
      onError: data => {
        setEpostData(new Error(data));
      },
      onSuccess: data => {
        setEpostData(data);
      }
    });
  }, [recordID, setEpostData]);

  // RENDER
  return (
    <EpostContext.Provider value={{
      epostData,
      clearData
    }}>
      <Component {...props} />
    </EpostContext.Provider>
  );
}
